import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import renderViewsState from '../shared/render-views-state';

import SwitchOffers from '../shared/switch';

import Form from './components/form';

lessRequire('modules/global-postback/main.less');

const Main = renderViewsState(props => {
	const { intl } = props;
	const switchControlConfig = [{
		className: '',
		title: intl('Настройки'),
		url: 'campaigns/global-postback/'
	}, {
		className: '',
		title: intl('Глобальный постбэк лог'),
		url: 'campaigns/global-postback/log/'
	}, {
		className: '',
		title: intl('Переотправка постбека'),
		url: 'campaigns/global-postback/resend/'
	}];

	return (
		<div className="global-postback container">
			<div className="content-container">
				<div className="content-container__title">
					<h2 className="font-proxima-nova-bold">{intl('Глобальный постбэк')}</h2>
					<div className="global-postback__switch">
						<SwitchOffers links={switchControlConfig} intl={intl}/>
					</div>
				</div>
				<div className="global-postback-content">
					<Form
						initialValues={{postbacks: props.form.data}}
						enableReinitialize={true}
						checkboxDisabledStatus={props.form.checkboxDisabledStatus}
						addField={props.addField}
						removeField={props.removeField}
						onChecked={props.checked}
						saveForm={props.formSaveData}
						errors={props.form.errors}
						changeUrl={props.changeUrl}
						postbackTypeErrors={props.postbackTypeErrors}
						fieldsLimit={props.fieldsLimit}
						affiliateID={props.affiliateID}
						intl={intl}
					/>
				</div>
			</div>
		</div>
	);
});

Main.propTypes = {
	formSaveData: PropTypes.func,
	checkboxDisabledStatus: PropTypes.object,
	logTable: PropTypes.object,
	addFiled: PropTypes.func,
	removeField: PropTypes.func,
	form: PropTypes.object,
	checked: PropTypes.func,
	errors: PropTypes.object,
	intl: PropTypes.func,
	postbackTypeErrors: PropTypes.array,
	fieldsLimit: PropTypes.number,
	affiliateID: PropTypes.number
};

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		affiliateID: selectors.getAffiliateId(state),
		form: selectors.getFormSettings(state),
		logTable: selectors.getLogTable(state),
		errors: selectors.getError(state),
		intl: selectors.getIntl(state),
		fieldsLimit: selectors.getFieldsLimit(state),
		postbackTypeErrors: selectors.getPostbackTypeErrors(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/main.js